module.exports = __webpack_public_path__ + "annualreview2017/static/img/being-part-of-a-community-energy-scheme.27535a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prosumer-wide/being-part-of-a-community-energy-scheme.png
// module id = 786
// module chunks = 0